export enum DatabaseFilesystemKind {
  InMemory = "in-memory",
  IndexedDB = "indexeddb",
}
